import { Toast, MessageBox } from 'mint-ui'
export default {
    data() {
        return {
            isNoProduct: false,
            isShowModal: false,
        };
    },
    methods: {
        // 处理提交订单返回错误
        handleSubmitErr(res, productId) {
            if (res.ErrMsg === '当前商品已购买过，限购一件。独乐乐不如众乐乐，分享给好友吧' ||
                res.ErrMsg === '当前商品已购买过或被关联的亲朋好友购买过，限购一件。独乐乐不如众乐乐，分享给好友吧~'
            ) {
                res.ErrMsg = res.ErrMsg === '当前商品已购买过或被关联的亲朋好友购买过，限购一件。独乐乐不如众乐乐，分享给好友吧~' ? '您已购买过或暂不满足当前商品的购买要求，无法进行购买，换件商品看看吧~' : res.ErrMsg
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '我知道了',
                    cancelButtonText: '删除收藏',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action !== 'confirm') {
                        this.delGoodsReq(productId);
                    }
                })
            } else if (res.ErrMsg === '免单卡不足') {
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '获取更多',
                    cancelButtonText: '留在此页',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action === 'confirm') {
                        this.$router.replace({
                            name: 'collarCartCenter'
                        })
                    } else {
                        this.fetchData()
                    }
                })
            } else if (res.ErrMsg === '当前账户已被限制购买，可点击下方按钮查看详情。如有疑问，请联系客服') {
                MessageBox({
                    title: '提示',
                    message: '当前账户已被限制购买，可点击下方按钮查看详情。如有疑问，请联系客服',
                    showCancelButton: true,
                    confirmButtonText: '查看详情',
                    cancelButtonText: '关闭',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action === 'confirm') {
                        this.$router.push({
                            name: "violationPage",
                            query: { type: 1 }
                        });
                    }
                })
            } else if (res.ErrMsg === '亲，需要升级成为V2会员以上才可购买此商品。购买完成2单并且成功邀请1位好友，即可升级为V2会员，快去升级吧~') {
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '我要升级',
                    cancelButtonText: '关闭',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action === 'confirm') {
                        this.$router.push({ name: 'memberUpgrade' })
                    }
                })
            } else if (res.ErrMsg === '存在待处理事项未完成，请尽快联系客服处理后，即可恢复正常购买') {
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '查看待处理',
                    cancelButtonText: '关闭',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action === 'confirm') {
                        this.$router.push({
                            name: "violationPage",
                            query: { type: 0 }
                        });
                    }
                })
            } else if (res.ErrMsg === '商品已临时下架，晚点再来看看吧') {
                MessageBox({
                    title: '提示',
                    message: '商品已开启优质买家（特殊）才允许购买，后续请继续购买其他商品并保持良好的购物行为，即可有机会升级至优质买家',
                    showCancelButton: true,
                    confirmButtonText: '我知道了',
                    cancelButtonText: '删除收藏',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action !== 'confirm') {
                        this.delGoodsReq(productId);
                    }
                })
            } else if (res.ErrMsg === '由于存在淘客订单，限制24小时购买相同店铺商品；购物时确保仅使用淘宝APP搜索购买，避免被再次限制') {
                MessageBox({
                    title: '提示',
                    message: `由于存在淘客订单，24小时内限制购买该店铺商品。<br>有关淘客的具体规则，可点击左侧查看规则进行查看。`,
                    showCancelButton: true,
                    confirmButtonText: '我知道了',
                    cancelButtonClass: 't_blue',
                    confirmButtonClass: 'c000',
                    cancelButtonText: '查看规则'
                }).then(action => {
                    if (action === 'confirm') {
                    } else {
                        this.$router.push({
                            name: 'violationDetail',
                            query: {
                                type: 0
                            }
                        })
                    }
                })
            } else if (
                /在近\d+天内已购买过同店铺内的商品，暂时无法给到你此优惠，请晚点再来/.test(res.ErrMsg) ||
                /在近\d+天内已购买过关联店铺内的商品，暂时无法给到你此优惠，请晚点再来/.test(res.ErrMsg) ||
                res.ErrMsg === `由于存在淘客订单，限制24小时购买相同商品；购物时确保仅使用${this.platformType ? '拼多多' : '淘宝'}APP搜索购买，避免被再次限制` ||
                res.ErrMsg === `由于存在淘客订单，限制24小时购买相同店铺商品；购物时确保仅使用${this.platformType ? '拼多多' : '淘宝'}APP搜索购买，避免被再次限制`
            ) {
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '我知道了',
                    cancelButtonText: '删除收藏',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action !== 'confirm') {
                        this.delGoodsReq(productId);
                    }
                })
            } else {
                MessageBox({
                    title: '提示',
                    message: res.ErrMsg,
                    showCancelButton: true,
                    confirmButtonText: '我知道了',
                    cancelButtonText: '删除收藏',
                    confirmButtonClass: 't_f23030'
                }).then(action => {
                    if (action !== 'confirm') {
                        this.delGoodsReq(productId);
                    }
                })
            }
        }
    }
}